module.exports = __webpack_public_path__ + "static/media/3 10 Tulleord Blastell er feil.2b79cb5f.mp3";